export const fromMilitaryToStandardTime = (militaryTimeNumber: number): string => {
    const timeMoment = militaryTimeNumber >= 1200 ? 'pm' : 'am';
    let timeNumber = militaryTimeNumber;

    let formattedTime;

    if (militaryTimeNumber > 1259) {
        timeNumber -= 1200;
    }

    if (militaryTimeNumber === 0) {
        return `12${timeMoment}`;
    }

    const cutOff = timeNumber < 1000 ? 1 : 2;
    const timeHours = timeNumber.toString().slice(0, cutOff);
    const timeMinutes = timeNumber.toString().slice(cutOff);

    if (timeMinutes !== '00') {
        formattedTime = `${timeHours}:${timeMinutes}${timeMoment}`;
    } else {
        formattedTime = `${timeHours}${timeMoment}`;
    }

    return formattedTime;
};
